import React from 'react';
import LoginContainer from '../containers/LoginContainer';

const Login: React.FC = () => {
  return <LoginContainer />;
};

export default Login;
